import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import { AppButton } from "@/shared/Components";
import { useAppDispatch } from "@/services/store";
import { PlusIcon } from "@/shared/icons";
import type { FC } from "react";
import { setContactsIsEdit, setCurrentPerson } from "../../slice";
import styles from "./styles.module.scss";

type Props = {
  type?: "float" | "classic";
};

export const AddContactButton: FC<Props> = ({ type = "classic" }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const addHandler = () => {
    dispatch(
      setCurrentPerson({
        id: `new-${uuid()}`,
        birthdaySDate: { day: null, month: null, year: null },
        firstName: null,
        middleName: null,
        lastName: null,
        gender: "NOT_DEFINED",
        title: null,
        group: null,
        birthday: null,
        additionalInformation: null,
        avatarFile: null,
        addresses: [],
        phones: [],
        anniversaries: [],
        emails: [],
        websites: [],
        socialNetworks: [],
        careers: [],
        competences: [],
        hobbies: [],
        personConnections: [],
        notes: [],
        professionalActivities: [],
        educations: [],
        tags: [],
        lastModifiedDate: "",
      }),
    );
    navigate(`${location.pathname.split("/")[2] ?? "generalInfo"}/`);
    dispatch(setContactsIsEdit(true));
  };
  return (
    <AppButton onClick={addHandler} type="primary" className={styles[type]}>
      {type === "classic" ? t("contactsPage.addContacts") : <PlusIcon className={styles.icon} />}
    </AppButton>
  );
};
